import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://uwowrramnuqrzrkerhhe.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV3b3dycmFtbnVxcnpya2VyaGhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYyODE1MzQsImV4cCI6MjA5MTg1NzUzNH0.f51a8bcT6Cwxq0ku2kI_WMi92D0flIbEWM2zXKGuOnY'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})